import type { ModelResolutionSuccess } from "../sync/modelNameResolver/types.js";
import type {
  InvokeModelResolutionDiagnostics,
  InvokeModelResolutionInput,
  InvokeRouterConfigSlice,
} from "./types.js";

export function buildInvokeModelDiagnostics(
  input: InvokeModelResolutionInput,
  resolution: ModelResolutionSuccess,
  router: InvokeRouterConfigSlice,
): InvokeModelResolutionDiagnostics {
  const viaProfile = resolution.resolvedVia.includes("ai-profiles-profile");
  const profileKey =
    input.model !== router.model || viaProfile ? input.model : undefined;

  return {
    originalProvider: input.provider,
    originalModel: input.model,
    modelId: resolution.modelId,
    routedViaOpenRouter: resolution.routedViaOpenRouter,
    confidence: resolution.confidence,
    resolvedVia: resolution.resolvedVia,
    profile: resolution.profile,
    choice: resolution.choice,
    profileKey,
    invokedModelId: resolution.modelId ?? router.model,
  };
}
